// extracted by mini-css-extract-plugin
module.exports = {"translate-wrapper":"translate_translate-wrapper__3DCJL","translate-icon":"translate_translate-icon__3zFXR","active":"translate_active__3Hyt4"};